import { createSlice } from '@reduxjs/toolkit';
import { showMessageError } from '@Utils/RenderUtils';
import SurveyThemeApi from './surveyThemeApi';
import toastr from 'toastr';

const initialState = {
  loading: false,
  loadingList: false,
  createLoading: false,
  errors: [],

  list: [],

  theme: {},
};

export const surveyThemeSlice = createSlice({
  name: 'surveyTheme',
  initialState,
  reducers: {
    setLoading(state, { payload }) {
      state.loading = payload;
    },
    setLoadingList(state, { payload }) {
      state.loadingList = payload;
    },
    setSurveyThemeList(state, { payload }) {
      state.list = payload;
    },
    setSurveyThemeListErrors(state, { payload }) {
      state.errors = payload;
    },
    setSurveyThemeCreateFetchStart(state) {
      state.createLoading = true;
    },
    setSurveyThemeCreateFetchSuccess(state) {
      state.createLoading = false;
      toastr.success('Has been created successfully');
    },
    setSurveyThemeCreateFetchFail(state) {
      state.createLoading = false;
    },
    setSurveyThemeViewSuccess(state, { payload }) {
      state.theme = payload;
    },
  },
});
export default surveyThemeSlice.reducer;

export const {
  setLoading,
  setLoadingList,
  setSurveyThemeList,
  setSurveyThemeListErrors,
  setSurveyThemeCreateFetchStart,
  setSurveyThemeCreateFetchSuccess,
  setSurveyThemeCreateFetchFail,
  setSurveyThemeViewSuccess,
} = surveyThemeSlice.actions;

export const fetchThemeList = (param) => async (dispatch) => {
  dispatch(setLoadingList(true));
  SurveyThemeApi.themeList(param)
    .then((res) => {
      dispatch(setSurveyThemeList(res));
    })
    .catch((error) => {
      dispatch(setSurveyThemeListErrors(error));
    })
    .finally(() => {
      dispatch(setLoadingList(false));
    });
};

export const surveyThemeCreateFetch = (theme) => async (dispatch) => {
  dispatch(setSurveyThemeCreateFetchStart());
  try {
    const response = await SurveyThemeApi.themeCreate(theme);
    dispatch(setSurveyThemeCreateFetchSuccess(response));
  } catch (e) {
    dispatch(setSurveyThemeCreateFetchFail(e));
    showMessageError(e);
  }
};

export const surveyThemeView = (id) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await SurveyThemeApi.themeView(id);
    dispatch(setSurveyThemeViewSuccess(response));
  } finally {
    dispatch(setLoading(false));
  }
};
